import { useChartControls } from "../ChartControlsContext";
import { CompactRangeButton } from "./CompactRangeButton";

// The presets RangeSelector shows on desktop when a chart sets none.
const DEFAULT_PRESETS: IntervalType[] = [
  "oneWeek",
  "oneMonth",
  "YTD",
  "oneYear",
  "threeYears",
  "fiveYears",
  "sinceBeginning",
];

// The chart's range as one calendar button on phones.
export const MobileRangeControl = () => {
  const { rangeProps, availableDateRanges } = useChartControls();

  return (
    <CompactRangeButton
      rangeProps={rangeProps}
      intervalTypes={availableDateRanges ?? DEFAULT_PRESETS}
    />
  );
};
